import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Tree from 'react-d3-tree';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'antd';
import isEmpty from 'lodash/isEmpty';

import * as pageActions from '../../../../../data/redux/page_details/actions';
import * as sessionFlowActions from '../../../../../data/redux/session_flow_details/actions';

import { APP_PAGES, APP_LAYOUT } from '../../../../../data/config/constants';
import { BRAND_INFO } from '../../../../../data/config/urls';
import { IconArrowDown } from '../../../../../data/assets/icons';

import CustomHeader from '../../../../../components/customheader';
import ShowMessage from '../../../../../components/showmessage';

const NODE = {
    total_node_width: 260,
    bubble_width: 150,
    percent_overlay_width: 50,
    left_overlay_width: 50,
    right_overlay_width: 60,
};

const TooltipBody = (props) => {
    return (
        <div className="ori-full-width" >
            {
                props.tooltip_data && props.tooltip_data.name &&
                <div className="ori-lr-pad-5 ori-tb-pad-3">
                    <p className="ori-font-xs"> Event </p>
                    <p className="ori-font-13 ori-font-bold">{props.tooltip_data.name}</p>
                </div>
            }
            {
                props.tooltip_data.attributes && props.tooltip_data.attributes.percentage &&
                <div className="ori-lr-pad-5 ori-tb-pad-3">
                    <p className="ori-font-xs">% of all sessions </p>
                    <p className="ori-font-sm ori-font-primary">{props.tooltip_data.attributes.percentage}</p>
                </div>
            }
            {
                props.tooltip_data.attributes && props.tooltip_data.attributes.count &&
                <div className="ori-lr-pad-5 ori-tb-pad-3">
                    <p className="ori-font-xs">Number of sessions </p>
                    <p className="ori-font-sm ori-font-primary">{props.tooltip_data.attributes.count}</p>
                </div>
            }
            {
                props.tooltip_data.attributes && props.tooltip_data.attributes.exit &&
                <div className="ori-lr-pad-5 ori-tb-pad-3">
                    <p className="ori-font-xs">% of sessions exit </p>
                    <p className="ori-font-sm ori-font-red">{props.tooltip_data.attributes.exit}</p>
                </div>
            }
        </div>
    );
}

const TreeNode = ({ nodeData }) => {
    const root_node = nodeData.type && nodeData.type === "root";
    const leaf_node = isEmpty(nodeData._children);
    return (
        <div className={classNames("ori-flex ori-flex-jfe")}>
            {
                !root_node &&
                <div className="ori-r-pad-5 ori-flex-column ori-flex-jc" style={{ width: `${NODE.left_overlay_width}px` }}>
                    {
                        nodeData.attributes && nodeData.attributes.percentage &&
                        <div className="ori-font-xs ori-lr-pad-3 ori-font-white ori-bg-black-light ori-border-radius-4 ori-space-nowrap ori-overflow-hidden ori-text-center">
                        <span>{ nodeData.attributes.percentage }</span>
                    </div>
                    }
                </div>
            }
            <Tooltip placement="right" overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white" title={<TooltipBody tooltip_data={nodeData} />}>
                <div className={classNames("ori-font-xs ori-flex-row ori-font-bold ori-font-white ori-box-shadow ori-text-overflow-dotted", { " ori-lr-pad-15 ori-tb-pad-7 ori-border-radius-4 ori-uppercase": root_node, " ori-lr-pad-10 ori-tb-pad-5 ori-border-radius-20 ": !root_node, "ori-bg-danger ": leaf_node || (leaf_node && root_node), "ori-bg-primary": !leaf_node && root_node, "ori-bg-aquamarine": !leaf_node && !root_node })} style={{ width: !root_node ? `${NODE.bubble_width}px` : "" }}>
                    {
                        !root_node &&
                        <div className="ori-r-pad-5">
                            <img src={BRAND_INFO.bot_icon_url} alt="" style={{ width: "16px", height: "18px" }} />
                        </div>
                    }
                    <div className="ori-text-overflow-dotted">
                        <span> {nodeData.name} </span>
                    </div>
                </div>
            </Tooltip>
            {
                !root_node &&
                <div className="ori-l-pad-5 ori-flex-column ori-flex-jc" style={{ width: `${NODE.right_overlay_width}px` }}>
                    {
                        nodeData.attributes && nodeData.attributes.exit &&
                        <div className="ori-font-xs ori-flex-row ori-lr-pad-3 ori-font-white ori-bg-black-light ori-border-radius-4 ori-text-center">
                            <div className="ori-font-white" style={{ stroke: "#fff" }}>
                                <IconArrowDown size={13} />
                            </div>
                            <div>
                                <span>{nodeData.attributes.exit}</span>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

class SessionFlow extends Component {
    componentWillMount() {
        const { actions } = this.props;
        actions.pageChanged(APP_PAGES.SESSION_FLOW, APP_PAGES.ANALYTICS);
    }

    componentDidMount() {
        const { actions, session_flow_details } = this.props;
        if (isEmpty(session_flow_details.session_flow)) {
            const payload = {
                startDate: session_flow_details.session_flow_filters.date_range[0],
                endDate: session_flow_details.session_flow_filters.date_range[1],
            };
            actions.getSessionFlowData(payload);
        }
    }

    handleSessionFlowDateRangeChange = (date_range) => {
        const { actions } = this.props;
        const payload = {
            startDate: date_range[0],
            endDate: date_range[1],
        };
        actions.getSessionFlowData(payload, actions.updateSessionFlowFilter(date_range, "session_flow_filters.date_range"));
    };

    render() {
        const { page_details, session_flow_details } = this.props;
        return (
            <div className="ori-lr-pad-10 oriSessionFlowContainer">
                <CustomHeader title="Session Flow" date_range={session_flow_details.session_flow_filters.date_range} onChangeDateRange={this.handleSessionFlowDateRangeChange} bottom_bordered show_date_range />
                {
                    !isEmpty(session_flow_details.session_flow) &&
                    <div className="ori-tb-pad-10 ori-full-width" style={{ height: page_details.device_data.screen_height * 1.2 }}>
                        <Tree data={session_flow_details.session_flow} zoomable={true}scaleExtent={{min: 1, max: 3}} initialDepth={1} styles={{ links: { stroke: '#9999994d', strokeWidth: 7 } }} separation={{ siblings: 0.5, nonSiblings: 1 }} nodeSvgShape={{ shape: "none" }} translate={{ x: 80, y: (page_details.device_data.screen_height - 60 - 55) / 2 }} nodeSize={{ x: 300, y: 100 }} nodeLabelComponent={{ render: <TreeNode />, foreignObjectWrapper: { style: { width: `${NODE.total_node_width}`, height: "75px", x: -195, y: -16 } } }} allowForeignObjects />
                    </div>
                }
                {
                    isEmpty(session_flow_details.session_flow) &&
                    <div className="ori-tb-pad-10" style={{ height: `${page_details.device_data.screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - 55 }px`}}>
                        <ShowMessage title="data not found" message="please select different date range. session data is not avaliable for this date range. " fade_item sad/>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        session_flow_details: state.session_flow_details
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, sessionFlowActions), dispatch)
    };
}

SessionFlow.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    session_flow_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
};

TreeNode.propTypes = {
    nodeData: PropTypes.object,
};

TooltipBody.propTypes = {
    tooltip_data: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(SessionFlow);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/sessionflow/index.js